import Router from '@module/router';

import Store from '@app/store';

function getPreviewUrl({ transferId, recipientId, secret, fileId }) {
  return ['/downloads', transferId, recipientId, secret, 'preview', fileId]
    .filter(Boolean)
    .join('/');
}

function goToPreview(id, secret, recipient_id, file_id) {
  if (!id || !secret || !file_id) {
    return;
  }

  const previewUrl = getPreviewUrl({
    transferId: id,
    secret,
    recipientId: recipient_id,
    fileId: file_id,
  });

  Router.navigateTo(previewUrl);
}

function getTransferDownloadUrl({ transferId, recipientId, secret }) {
  return ['/downloads', transferId, recipientId, secret]
    .filter(Boolean)
    .join('/');
}

function getGridUrl({ transferId, recipientId, secret }) {
  const downloadUrl = getTransferDownloadUrl({
    transferId,
    recipientId,
    secret,
  });

  return `${downloadUrl}/grid`;
}

function goToGrid() {
  const {
    transfer: { id, secret, recipient_id },
  } = Store.getState();

  const gridUrl = getGridUrl({
    transferId: id,
    recipientId: recipient_id,
    secret,
  });

  Router.navigateTo(gridUrl);
}

// TODO: Make this a toggleGrid function
function closePreview() {
  const {
    transfer: { id, secret, recipient_id },
  } = Store.getState();
  const downloadUrl = getTransferDownloadUrl({
    transferId: id,
    recipientId: recipient_id,
    secret,
  });

  Router.navigateTo(downloadUrl);
}

function getVariantForPreviewButtonExperiment({ isMobile }) {
  if (isMobile) {
    return false;
  }
  const {
    session: {
      region: { country },
    },
  } = Store.getState();

  return country === 'ES';
}

export default {
  goToPreview,
  goToGrid,
  closePreview,
  getVariantForPreviewButtonExperiment,
  getGridUrl,
  getTransferDownloadUrl,
  getPreviewUrl,
};
